import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class PcdDataService {
	public applicationId: number;
	public acronym: string;
	public taskName: string;
	public formView: string;
	public statusId: number;
	public referenceNo: string;

	// constructor() {}
	// public setApplicationId(id, acronym, formView?, statusId?) {
	// 	this.applicationId = id;
	// 	this.acronym = acronym;
	// 	this.statusId = statusId;
	// 	this.formView = formView;
	// }

	private STORAGE_KEY = 'pcdDataAplicant';

	constructor() {
		this.loadFromStorage(); // load data on service creation
	}

	public setApplicationId(id: number, acronym: string, formView?, statusId?) {
		this.applicationId = id;
		this.acronym = acronym;
		this.statusId = statusId;
		this.formView = formView;

		this.saveToStorage(); // save immediately
	}

	private saveToStorage() {
		const data = {
			applicationId: this.applicationId,
			acronym: this.acronym,
			statusId: this.statusId,
			formView: this.formView
		};

		localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
	}

	private loadFromStorage() {
		const data = localStorage.getItem(this.STORAGE_KEY);
		if (data) {
			const parsed = JSON.parse(data);
			this.applicationId = parsed.applicationId;
			this.acronym = parsed.acronym;
			this.statusId = parsed.statusId;
			this.formView = parsed.formView;
		}
	}

	public clearStorage() {
		this.applicationId = null;
		this.acronym = null;
		this.taskName = null;
		this.formView = null;
		this.statusId = null;
		this.referenceNo = null;
		localStorage.removeItem(this.STORAGE_KEY);
	}
}
